import { useEffect, useState, useCallback } from "react";
import { Grid, Row, Col, Card, Text, Table, Button } from "rsuite";
import "rsuite/dist/rsuite.min.css";

import MDBox from "components/atoms/MDBox";
import DashboardLayout from "components/templates/DashboardLayout";
import Topnav from "components/organisms/Topnav";
import DashboardFooter from "components/organisms/Footer/DashboardFooter";
import PermissionDenied from "components/organisms/PermissionDenied";
//import ErrorSnackbar from "components/molecules/Notifications/ErrorSnackbar";
//import SuccessSnackbar from "components/molecules/Notifications/SuccessSnackbar";
//import InvalidOperation from "components/organisms/InvalidOperation";
//import IncompleteOperation from "components/organisms/IncompleteOperation";
//import SubmissionProgress from "components/organisms/SubmissionProgress";

import { AllowedTo } from "react-abac";
import { useDocument } from "hooks/useDocument";
import { Permission } from "models/abac";
import tablestyles from "pages/settings/users2/tablestyles.module.css";
import CheckOutlineIcon from "@rsuite/icons/CheckOutline";
import CloseOutlineIcon from "@rsuite/icons/CloseOutline";

const { Column, HeaderCell, Cell } = Table;

function AlertRecipients() {
  const { retrieveDocs } = useDocument();
  const modePermission = Permission.VIEW_ADMIN_DASHBOARD;
  const [tableData, setTableData] = useState([]);

  /* [2] Table */
  const [sortColumn, setSortColumn] = useState(null);
  const [sortType, setSortType] = useState(null);
  const [tableLoading, setTableLoading] = useState(false);

  // 2.1 Sample data for the table
  // 2.2 Function to sort the table data based on the current sort column and type
  const getData = () => {
    if (sortColumn && sortType) {
      return tableData.sort((a, b) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string") {
          x = x.charCodeAt();
        }
        if (typeof y === "string") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
    return tableData;
  };

  const handleSortColumn = (sortColumn, sortType) => {
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
  };

  const formatUserData = useCallback((usersData) => {
    const tableData = usersData.map((doc, index) => {
      return {
        id: index + 1,
        firstName: doc.data.firstName,
        phoneNumber: doc.data.phoneNumber,
        status: "Active",
      };
    });

    return tableData;
  }, []);

  const fetchUsers = useCallback(async () => {
    const usersQueries = {
      whereQueries: [
        {
          field: "deletedAt",
          condition: "==",
          value: null,
        },
      ],
      orderByQueries: [
        {
          field: "firstName",
          direction: "asc",
        },
      ],
    };

    const usersData = await retrieveDocs("alertreceivers", usersQueries);
    const tableData = await formatUserData(usersData);

    console.log(JSON.stringify(tableData, null, 2));

    //console.log(JSON.stringify(tableData, null, 2));

    setTableData(tableData);
  }, [retrieveDocs, formatUserData]);

  const updateTable = useCallback(async () => {
    setTableLoading(true);
    setTimeout(() => {
      fetchUsers();

      setTableLoading(false);
    }, 2000);
  }, [fetchUsers]);

  useEffect(() => {
    updateTable();
  }, [updateTable]);

  return (
    <DashboardLayout>
      <Topnav title="Telegram Alert Recipients" />
      <AllowedTo perform={modePermission} no={() => <PermissionDenied />}>
        <>
          <MDBox mb={4} />
          <Grid fluid>
            <Row gutter={[9, 18]}>
              <Col span={{ xs: 24 }}>
                <Card size="md" shaded>
                  <Card.Header backgroundColor={"green"}>
                    <Text
                      size="lg"
                      style={{
                        textAlign: "left",
                        width: "100%",
                        color: "white",
                        paddingBottom: "6px",
                      }}
                    >
                      Enrolled Recipients
                    </Text>
                  </Card.Header>
                  <Card.Body>
                    <Table
                      height={910}
                      data={getData()}
                      sortColumn={sortColumn}
                      sortType={sortType}
                      onSortColumn={handleSortColumn}
                      loading={tableLoading}
                      bordered={true}
                      locale={{
                        emptyMessage: "",
                      }}
                    >
                      {/* Id */}
                      <Column width={60} align="center" sortable>
                        <HeaderCell className={tablestyles.customHeader}>
                          Id
                        </HeaderCell>
                        <Cell dataKey="id" className={tablestyles.customCell} />
                      </Column>

                      {/* First Name */}
                      <Column flexGrow={1} align="center" sortable>
                        <HeaderCell className={tablestyles.customHeader}>
                          First Name
                        </HeaderCell>
                        <Cell
                          dataKey="firstName"
                          className={tablestyles.customCell}
                        />
                      </Column>

                      {/* Phone Number */}
                      <Column flexGrow={2} align="center" sortable>
                        <HeaderCell className={tablestyles.customHeader}>
                          Phone Number
                        </HeaderCell>
                        <Cell
                          dataKey="phoneNumber"
                          className={tablestyles.customCell}
                          style={{
                            whiteSpace: "normal",
                            wordWrap: "break-word",
                          }}
                        />
                      </Column>

                      {/* Enable/Disable Button */}
                      <Column width={120} align="center">
                        <HeaderCell>...</HeaderCell>
                        <Cell style={{ padding: "3px" }}>
                          {(rowData) => {
                            return rowData.status === "Active" ? (
                              <Button
                                appearance="primary"
                                startIcon={<CloseOutlineIcon />}
                                color="orange"
                                onClick={() => {
                                  console.log(
                                    "Deactivate user with id:",
                                    rowData.phoneNumber,
                                  );
                                }}
                              >
                                Deactivate
                              </Button>
                            ) : (
                              <Button
                                appearance="primary"
                                startIcon={<CheckOutlineIcon />}
                                color="green"
                                onClick={() => {
                                  console.log(
                                    "Activate user with id:",
                                    rowData.phoneNumber,
                                  );
                                }}
                              >
                                Activate
                              </Button>
                            );
                          }}
                        </Cell>
                      </Column>
                    </Table>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Grid>
          <DashboardFooter />
        </>
      </AllowedTo>
    </DashboardLayout>
  );
}

export default AlertRecipients;
